export const computeInkapagoComission = (price: number): number => {
  return price < 15000
    ? Math.ceil((price * 45) / 1000) + 150
    : Math.ceil((price * 50) / 1000) + 210;
};

export const getPENFromCents = (amount: number | undefined): string => {
  return amount === 0 || amount ? `S/.${(amount / 100).toFixed(2)}` : "-";
};
